
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Trophy } from "lucide-react";

interface TopPerformersFilterProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

const TopPerformersFilter = ({ checked, onCheckedChange }: TopPerformersFilterProps) => {
  return (
    <div className="mb-6">
      <Label className="text-sm font-bold text-[#1B2F47] block mb-2">
        Top Performers
      </Label>
      <div className="flex items-center space-x-2">
        <Checkbox
          id="topPerformers"
          checked={checked}
          onCheckedChange={(checked) => onCheckedChange(checked as boolean)}
          className="border-[#007BFF] data-[state=checked]:bg-[#007BFF] data-[state=checked]:border-[#007BFF]"
        />
        <Label
          htmlFor="topPerformers"
          className="text-sm text-[#1B2F47] cursor-pointer flex items-center gap-2"
        >
          <Trophy className="w-4 h-4 text-[#FFC300]" />
          Top 10 Performers
        </Label>
      </div>
    </div>
  );
};

export default TopPerformersFilter;

